import btnCenter from '@/assets/images/btn_center.png'
import btnRight from '@/assets/images/btn_right.png'
export default [
  {
    id: 1,
    name: '按钮',
    key: 'XrButton',
    icon: 'ios-image',
    disabled: false,
    attr: [
      {
        name: 'position',
        parent: '',
        key: 'float',
        label: '位置',
        element_type: 'GROUPBOX',
        field_type: 'String',
        position: 'none',
        restriction: [
          {
            label: '顶部悬浮',
            value: 'top'
          }, {
            label: '底部悬浮',
            value: 'bottom'
          }, {
            label: '不悬浮',
            value: 'none'
          }
        ]
      },
      {
        name: 'color',
        parent: '',
        key: 'bg_color',
        label: '背景',
        element_type: 'COLOR',
        field_type: 'String',
        color: '#fff',
        restriction: {
        }
      },
      {
        name: 'btnstyle',
        parent: '',
        label: '按钮样式',
        element_type: 'GROUPBOX',
        field_type: 'String',
        btnstyle: 'block',
        restriction: [
          {
            label: '样式1',
            img: btnCenter,
            value: 'block'
          },
          {
            label: '样式2',
            img: btnRight,
            value: 'inline'
          }
        ]
      },
      {
        name: 'align',
        parent: '',
        label: '按钮位置',
        element_type: 'GROUPBOX',
        field_type: 'String',
        align: 'center',
        restriction: [
          {
            label: '居中',
            value: 'center'
          },
          {
            label: '居右',
            value: 'end'
          }
        ],
        relyon: {
          index: 2,
          value: 'inline'
        }
      },
      {
        name: 'image',
        parent: '',
        key: 'bg_image',
        label: '上传素材',
        up_txt: '上传按钮图片',
        rules: '建议:750x120px',
        element_type: 'UPLOAD',
        field_type: 'String',
        image: '',
        restriction: {
        }
      },
      {
        name: 'btn_bg_image',
        parent: '',
        label: '',
        up_txt: '上传背景图片',
        rules: '建议:750x120px',
        disabled_info: true,
        inline: true,
        element_type: 'UPLOAD',
        field_type: 'String',
        btn_bg_image: '',
        restriction: {
        },
        relyon: {
          index: 2,
          value: 'inline'
        }
      },
      {
        name: 'tip',
        parent: '',
        label: '',
        element_type: 'TIPS',
        field_type: '',
        tip: '注意：用于头条自动建落地页时，按钮图片的高度<font color="green">小于96PX</font>，否则可能报错',
        restriction: {
        },
        relyon: {
          index: 2,
          value: 'block'
        }
      }
    ]
  },
  {
    id: 2,
    name: '图片',
    key: 'XrPicture',
    icon: 'ios-image-outline',
    disabled: false,
    attr: [
      {
        name: 'downlink',
        parent: '',
        key: 'link',
        label: '是否开启链接',
        element_type: 'SWITCH',
        field_type: 'Boolean',
        downlink: false,
        restriction: {
        }
      },
      {
        name: 'href',
        parent: '',
        label: '链接地址',
        element_type: 'TEXT',
        field_type: 'String',
        href: '',
        required: true,
        restriction: {
          pattern: '^((https|http)?://)[^\\s]+',
          placeholder: '请使用http://或https://开头,不超过1024个字符'
        },
        relyon: {
          index: 0,
          value: true
        }
      },
      {
        name: 'image',
        parent: '',
        key: 'image_url',
        label: '图片',
        element_type: 'UPLOAD',
        field_type: 'String',
        image: '',
        restriction: {
        }
      }
    ]
  },
  {
    id: 6,
    name: '文本',
    key: 'XrSimpleText',
    icon: 'md-text',
    disabled: false,
    attr: [
      {
        name: 'text',
        parent: '',
        key: 'content',
        label: '文案',
        element_type: 'TEXTAREA',
        field_type: 'String',
        text: '',
        required: true,
        restriction: {
          max: 100,
          pattern: '[<>]+',
          placeholder: '最大100个字符，1个中文等于2个字符'
        }
      },
      {
        name: 'font_family',
        parent: '',
        key: 'font_family',
        label: '字体',
        element_type: 'SELECTBOX',
        field_type: 'String',
        font_family: 'font-0',
        restriction: [
          {
            value: 'font-0',
            label: '默认字体',
            disabled: true
          },
          {
            value: 'font-4',
            label: '方正仿宋',
            disabled: true
          }
        ]
      },
      {
        name: 'font_size',
        parent: '',
        key: 'font_size',
        label: '字号',
        element_type: 'SELECTBOX',
        field_type: 'Number',
        font_size: 14,
        restriction: [
          {
            value: 12,
            label: '12'
          },
          {
            value: 14,
            label: '14'
          },
          {
            value: 18,
            label: '18'
          },
          {
            value: 20,
            label: '20'
          },
          {
            value: 22,
            label: '22'
          },
          {
            value: 24,
            label: '24'
          },
          {
            value: 28,
            label: '28'
          },
          {
            value: 36,
            label: '36'
          },
          {
            value: 48,
            label: '48'
          },
          {
            value: 64,
            label: '64'
          },
          {
            value: 72,
            label: '72'
          },
          {
            value: 144,
            label: '144'
          }
        ]
      },
      {
        name: 'color',
        parent: '',
        key: 'color',
        label: '文字颜色',
        element_type: 'COLOR',
        field_type: 'String',
        color: '#333',
        restriction: {
        }
      },
      {
        name: 'format',
        parent: '',
        label: '排列',
        element_type: 'STRUCT',
        field_type: 'Object',
        children: [
          {
            name: 'letter_spacing',
            parent: 'format',
            key: 'letter_spacing',
            label: '字间距',
            element_type: 'SELECTBOX',
            field_type: 'Number',
            letter_spacing: 0,
            restriction: [
              {
                value: 0,
                label: '0'
              },
              {
                value: 0.5,
                label: '0.5'
              },
              {
                value: 1,
                label: '1'
              },
              {
                value: 1.5,
                label: '1.5'
              },
              {
                value: 2,
                label: '2'
              },
              {
                value: 2.5,
                label: '2.5'
              },
              {
                value: 3,
                label: '3'
              },
              {
                value: 4,
                label: '4'
              },
              {
                value: 5,
                label: '5'
              }
            ]
          },
          {
            name: 'line_height',
            parent: 'format',
            key: 'line_height',
            label: '行高',
            element_type: 'SELECTBOX',
            field_type: 'Number',
            line_height: 2,
            restriction: [
              {
                value: 1,
                label: '1'
              },
              {
                value: 1.2,
                label: '1.2'
              },
              {
                value: 1.5,
                label: '1.5'
              },
              {
                value: 1.75,
                label: '1.75'
              },
              {
                value: 2,
                label: '2'
              },
              {
                value: 2.5,
                label: '2.5'
              },
              {
                value: 3,
                label: '3'
              },
              {
                value: 4,
                label: '4'
              },
              {
                value: 5,
                label: '5'
              }
            ]
          },
          {
            name: 'font_style',
            parent: 'format',
            key: 'font_style',
            label: '',
            element_type: 'GROUPMIXCHECK',
            field_type: 'Array',
            font_style: [],
            restriction: [
              {
                label: 'B',
                value: 'bold'
              },
              {
                label: 'I',
                value: 'italic'
              },
              {
                label: 'U',
                value: 'underline'
              }
            ]
          },
          {
            name: 'text_align',
            parent: 'format',
            key: 'text_align',
            label: '',
            element_type: 'GROUPICON',
            field_type: 'String',
            text_align: 'center',
            restriction: [
              {
                label: 'align-left',
                value: 'left'
              },
              {
                label: 'align-center',
                value: 'center'
              },
              {
                label: 'align-right',
                value: 'right'
              }
            ]
          }
        ],
        restriction: {
        }
      },
      {
        name: 'link',
        parent: '',
        key: 'link',
        label: '是否开启链接',
        element_type: 'SWITCH',
        field_type: 'Boolean',
        link: false,
        restriction: {
        }
      },
      {
        name: 'href',
        parent: '',
        label: '链接地址',
        element_type: 'TEXT',
        field_type: 'String',
        href: '',
        required: true,
        restriction: {
          pattern: '^((https|http)?://)[^\\s]+',
          placeholder: '请使用http://或https://开头,不超过1024个字符'
        },
        relyon: {
          index: 5,
          value: true
        }
      }
    ]
  },
  {
    id: 5,
    name: '辅助色块',
    icon: 'ios-color-palette',
    disabled: false,
    attr: [
      {
        name: 'color',
        parent: '',
        label: '颜色',
        element_type: 'COLOR',
        field_type: 'String',
        color: '#fff',
        restriction: {
        }
      },
      {
        name: 'height',
        parent: '',
        label: '高度(px)',
        element_type: 'SLIDER',
        field_type: 'Number',
        height: 50,
        restriction: {
          min: 10,
          max: 200
        }
      }
    ]
  },
  {
    id: 3,
    name: '视频',
    icon: 'logo-youtube',
    disabled: true
  },
  {
    id: 4,
    name: '轮播图',
    icon: 'ios-images-outline',
    disabled: true
  }
]
